import Button from "domains/ui/components/Button";
import Icon from "domains/ui/components/Icon";

import { Box, Heading, HStack, Image, Text, VStack } from "@chakra-ui/react";

export default function BlendModalHeader() {
  return (
    <VStack
      align="stretch"
      overflow="hidden"
      w="100%"
      shouldWrapChildren
      spacing={12}
    >
      <Box
        pos="relative"
        p={10}
        borderRadius="md"
        bgColor="backgroundSecondary.500"
      >
        <Box
          pos="relative"
          zIndex="docked"
          w={["100%", "100%", "75%"]}
          color="textPrimary"
          textAlign="left"
        >
          <Heading mb={2} size="md">
            Create Distinct Styles by Combining Models.
          </Heading>
          <Text size="body.md">
            Merge LoRA models to craft your own unique aesthetics.
          </Text>
          <HStack>
            <Button
              mt={4}
              externalLink="https://youtu.be/v5mTB-Bggio?feature=shared"
              leftIcon={<Icon id="Domains/Tools/Video" />}
              size="sm"
            >
              Overview
            </Button>
            <Button
              mt={4}
              size="sm"
              variant="secondary"
              externalLink="https://help.scenario.com/en/articles/merge-models-to-create-unique-styles"
            >
              Ressource Center
            </Button>
          </HStack>
        </Box>
        <Image
          pos="absolute"
          top={0}
          right={"10%"}
          display={["none", "none", "none", "none", "block"]}
          h="full"
          alt="Blend Header Image"
          src="/ui/blend-header-image.png"
        />
      </Box>
    </VStack>
  );
}
